/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdCellProps, TdCellGroupProps } from './type';

export const cellDefaultProps: TdCellProps = { align: 'middle', arrow: false, bordered: true, required: false };

export const cellGroupDefaultProps: TdCellGroupProps = { bordered: false, theme: 'default' };
